import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menulteral',
  templateUrl: './menulteral.component.html',
  styleUrls: ['./menulteral.component.css']
})
export class MenulteralComponent implements OnInit {

  isBuscar = false;
  isInfo = false;
  isGourmet = false;
  isComida = false;
  isCine = false;

  HayZonaGourmet = true;
  HayPatiocomida = true;

  rutaActual = '';


  constructor(private router: Router) {
    if (event instanceof NavigationEnd) {
      this.getRoute();
    }
   }

  ngOnInit() {
    this.HayPatiocomida = environment.patioDeComida === 0 ?  false : true;
    this.HayZonaGourmet = environment.zonaGourmet === 0 ?  false : true;
    this.getRoute();
  }

  public getRoute() {
    const rutaSeparada = this.router.url.split('/');
    if ( rutaSeparada[1] === 'pelicula') {
      this.rutaActual = 'cine';
    } else {
      this.rutaActual = rutaSeparada.length === 2 ? rutaSeparada[1] : rutaSeparada.length > 2 ?  rutaSeparada[2] : '';
    }
  }

}
